import { isDesktop } from "react-device-detect";
import { useDataDog } from "../context/DataDogContext";
import { useMatchDetailsStore } from "../stores/StoreContext";

export const useAppPlayStore = () => {
  const { sendEventToDataDog } = useDataDog();
  const isIOS = () => /iPhone|iPad|iPod/i.test(navigator.userAgent);
  const isAndroid = () => /Android/i.test(navigator.userAgent);
  const { matchDetails } = useMatchDetailsStore();
  const handleIOSClick = () => {
    sendEventToDataDog("install_ios", {
      ios_click: "IOS app store button clicked",
      match_name: matchDetails?.name ?? "",
      match_date: matchDetails?.date ?? "",
    });
    if (!isDesktop && isIOS()) {
      // // Try deep link first using location
      window.location.href = "ultra://home";

      // // Fallback after short delay
      setTimeout(() => {
        window.location.href = `https://apps.apple.com/us/app/${process.env.REACT_APP_IOS_BUNDLE_ID}`;
      }, 3000);
    } else {
      // Desktop fallback
      window.open(
        `https://apps.apple.com/us/app/${process.env.REACT_APP_IOS_BUNDLE_ID}`,
        "_blank"
      );
    }
  };

  const handleAndroidClick = () => {
    sendEventToDataDog("install_android", {
      android_click: "Android app store button clicked",
      match_name: matchDetails?.name ?? "",
      match_date: matchDetails?.date ?? "",
    });
    if (!isDesktop && isAndroid()) {
      // Intent scheme for Android
      window.location.href = `intent://home#Intent;scheme=ultra;package=com.ultrapadel;S.browser_fallback_url=https://play.google.com/store/apps/details?id=${process.env.REACT_APP_ANDROID_BUNDLE_ID};end`;
    } else {
      // Desktop fallback
      window.open(
        `https://play.google.com/store/apps/details?id=${process.env.REACT_APP_ANDROID_BUNDLE_ID}`,
        "_blank"
      );
    }
  };

  return {
    handleAndroidClick,
    handleIOSClick,
  };
};
